import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'lc-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent {

  @Input('show') show_cart_popup: boolean;
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(public dataService: DataService) { }

  close_popup() {
    this.show_cart_popup = false;
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/shopping-cart/shopping-cart.component.ts